import React from 'react';
import { Helmet } from 'react-helmet-async';
import profileImage from '../assets/images/annette-main-img.png';

const Seo = () => {
  const siteUrl = "https://annettefinney.com";
  const imageUrl = `${siteUrl}${profileImage}`;
  const title = "Annette Finney | Graphic & Visual Designer Portfolio";
  const description = "Explore the professional portfolio of Annette Finney, a skilled graphic designer, visual designer, video editor, and motion graphics artist. Specializing in creating compelling visual experiences.";

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Person",
        "name": "Annette Finney",
        "url": siteUrl,
        "sameAs": [
          // Add social media links here when available
        ],
        "jobTitle": "Graphic Designer and Video Editor"
      },
      {
        "@type": "WebSite",
        "url": siteUrl,
        "name": "Annette Finney Portfolio",
        "publisher": {
          "@type": "Person",
          "name": "Annette Finney"
        },
        "inLanguage": "en-US"
      }
    ]
  };

  return (
    <Helmet>
      {/* Standard SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={siteUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={siteUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default Seo;
